// InfoTooltip prose shared by both Model Insights widgets (identical wording in each). Kept
// as single-line strings that match the whitespace-collapsed JSX text they replace, so the
// rendered tooltip text is byte-identical.

export const SATURATION_INFO_COPY =
  'Most media tactics will exhibit some form of diminishing returns, due to additional ' +
  'investment reaching less qualified audiences and/or additional user frequency having ' +
  'diminished impact. The model training process estimates the shape of these saturation ' +
  'curves on a channel by channel basis. Examining these curves yields insight into the ' +
  'scalability of each channel and the optimality of incremental investments (see above section).';

export const EFFECT_DECAY_INFO_COPY =
  'Few consumers, upon being exposed to an advertisement, drop everything and respond ' +
  'immediately; there is almost always some lag between exposure and response. The model ' +
  'training process estimates the extent of this response lag on a channel by channel basis ' +
  'using a technique known as Adstock. Typically (though not always), we see upper-funnel ' +
  'tactics having longer response lags and lower-funnel tactics converting more quickly. ' +
  'Examining these curves can help us understand channel properties and set appropriate ' +
  'expectations for channel investments.';
